module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-section c-section--complete",
    style: (("background-image: url(" + _vm.baseUrl + "img/bg-colors.svg)"))
  }, [_c('main-header'), _vm._v(" "), _c('div', {
    staticClass: "c-section__item"
  }, [_c('div', {
    staticClass: "o-container o-container--medium"
  }, [_c('div', {
    staticClass: "c-complete-intro"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-complete-intro__column"
  }, [_c('div', {
    staticClass: "c-complete-intro__img"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/chest-complete.png"),
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-section__item"
  }, [_c('div', {
    staticClass: "o-container o-container--medium"
  }, [_c('div', {
    staticClass: "c-complete-inari"
  }, [_c('div', {
    staticClass: "c-inari c-inari--complete"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "c-section__item"
  }, [_c('div', {
    staticClass: "o-container o-container--large"
  }, [_c('div', {
    staticClass: "c-scroll c-scroll--complete"
  }, [_c('img', {
    staticClass: "c-scroll__top",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/top-complete.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-scroll__middle"
  }, [_c('div', {
    staticClass: "c-complete-scroll"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "c-arrow-down"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll__container"
  }, [_c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__intro"
  }, [_c('div', {
    staticClass: "c-old-man"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/old-man.svg"),
      "alt": "",
      "width": "85"
    }
  })]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__what"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "c-bed-rise"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/bed-rise.svg"),
      "alt": "",
      "width": "285"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__flower"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "c-flower-diagram"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/flower-diagram.svg"),
      "alt": "",
      "width": "425"
    }
  })])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__steps"
  }, [_c('h3', [_vm._v("The 8 steps of ikigai")]), _vm._v(" "), _c('tiny-slider', {
    ref: "stepsSlider",
    staticClass: "c-slider c-slider--steps",
    attrs: {
      "controls": true,
      "controlsText": ['<span>Previous</span>', '<span>Next</span>'],
      "nav": true,
      "arrowKeys": true,
      "mouse-drag": true,
      "loop": true,
      "items": "1"
    }
  }, [_c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("1. Slow down and smell the cherry blossoms")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/cherry-blossoms.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Modern life moves fast. Slow down and you might just find that what you’re chasing will catch up to you. Take a break from technology and live in the moment. Let your senses enjoy the sights and sounds of your surroundings.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Clear your mind with a 25 minute walk. Leave your phone at home.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("2. Immerse yourself in what fulfills you")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/singing.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("When we focus our energy in the wrong places, we only have time to scratch the surface of life. The greatest experiences come when we dive in with 100% commitment, allowing it to consume us completely. It can take up to ten years to become a sushi chef!")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Spend 10 minutes working on your passion every day for the next 30 days.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("3. Find your zen"), _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/zen-man.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("In Japan, we have practiced meditation for over 1500 years. Meditation allows us to focus and control our emotions and outlook on life amidst daily distractions and brings us closer to finding our zen. Silence is full of answers.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Meditate for 15-30 minutes twice per week.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("4. Work to live, don’t live to work")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/work.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Fulfilling work is healthy for the soul but when life is taken over by work, the soul has no room to grow. It is also important to reflect if your work still aligns with your values and benefits society.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Is your work taking time away from yourself and the people that matter to you? Make changes if necessary.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("5. Prioritise your goals")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/goals.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("In modern life, we are often pulled in many directions at the same time. It’s impossible to please everyone, so you need to prioritise what's most important to you first. If you are not making your own goals, you are probably working on someone else's.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Write down short term and long term goals and give each one a specific time frame.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("6. Try something new")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/new-drum.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("It’s important to preserve our childlike curiosity. This will open up new paths for us. It takes many strokes to paint your life. Keep learning and add new strokes to the canvas. Soon, you’ll be able to see your ikigai within the masterpiece.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Whether you’re at home or travelling to Japan, look at what activities or classes are available in your area.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("7. Take action today")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/rocket.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Procrastination will steal your time away and take you further away from your goals. Stop talking of tomorrow and start taking steps to finding your ikigai.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: Print out and fill in your own MyikiGuide (below)")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("8. Just keep going")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/steps/rock-climbing.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Your journey to discovering your ikigai will require persistence. Most people don’t find their passion straight away, sometimes it takes at least a few tries until you find something which truly fulfills you.")]), _vm._v(" "), _c('p', [_vm._v("Take Action: When you hit a barrier, take a breath, then carry on.")])])])])], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "c-arrow-down"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-myikiguide"
  }, [_c('img', {
    staticClass: "c-myikiguide__img",
    attrs: {
      "src": (_vm.baseUrl + "img/myikiguide.png"),
      "alt": "MyIkiGuide"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "c-button c-button--primary",
    attrs: {
      "href": "https://www.jnto.org.au/app/uploads/2018/05/Myikiguide.pdf?utm_medium=Website&utm_source=Website&utm_campaign=SecretScrolls&utm_content=Myikiguide",
      "download": "",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Download MyIkiguide');
      }
    }
  }, [_vm._v("DOWNLOAD MYIKIGUIDE AS PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__passions"
  }, [_c('h3', [_vm._v("Passions")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Japan is filled with endless passions for you to pursue. Here are three examples:")]), _vm._v(" "), _c('tiny-slider', {
    ref: "passionsSlider",
    staticClass: "c-slider c-slider--3col c-slider--passions",
    attrs: {
      "controls": true,
      "controlsText": ['<span>Previous</span>', '<span>Next</span>'],
      "nav": true,
      "arrowKeys": true,
      "mouse-drag": true,
      "loop": true,
      "items": "1"
    }
  }, [_c('div', {
    staticClass: "c-slider__slide"
  }, [_c('header', [_c('h4', [_vm._v("Food")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/passions/food.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("If cooking is your passion, then follow your nose to Kagawa Prefecture on Shikoku Island. It is renowned for producing the country’s best tasting udon noodles with over 800 udon noodle shops to choose from. Here, there are many udon-making classes you can take to learn the full process including dough kneading and udon cutting from local masters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide c-slider__slide--green"
  }, [_c('header', [_c('h4', [_vm._v("Martial Arts")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/passions/martial-arts.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("Keeee-yah! If you’re a karate enthusiast, then you have to visit Okinawa - the birthplace of karate. There are approximately 400 dojos (schools) for you to perfect your roundhouse kick. There’s even a famous bar dedicated to karate with rare memorabilia, exhibits and plenty of Japanese whisky!")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-slider__slide c-slider__slide--gold"
  }, [_c('header', [_c('h4', [_vm._v("Art")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/passions/art.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("For the artistic eye, the Setouchi region has your name written on its canvas. The island of Teshima is home to some of the most beautiful architecture in the world such as the Teshima Art Museum while the island of Naoshima is studded with modern art museums designed by the likes of Tadao Ando, artworks from Monet and Matisse, and iconic outdoor sculptures.")])])])])], 1)])]), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/bottom-complete.svg"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-section__item"
  }, [_c('div', {
    staticClass: "o-container o-container--medium"
  }, [_c('div', {
    staticClass: "c-complete-outro"
  }, [_c('a', {
    staticClass: "c-button c-button--primary",
    attrs: {
      "href": "https://www.jnto.org.au/app/uploads/2018/05/Printable-Scroll.pdf?utm_medium=Website&utm_source=Website&utm_campaign=SecretScrolls&utm_content=Scroll",
      "download": "",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Download Scroll');
      }
    }
  }, [_vm._v("DOWNLOAD SCROLL")])]), _vm._v(" "), _c('ul', {
    staticClass: "c-social"
  }, [_c('li', [_c('button', {
    staticClass: "c-button c-button--alt c-button--facebook",
    on: {
      "click": function($event) {
        _vm.popup('Facebook')
      }
    }
  }, [_c('icon', {
    staticClass: "c-button__icon",
    attrs: {
      "name": "facebook",
      "role": "img",
      "label": "Facebook"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share on Facebook")])], 1)]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "c-button c-button--alt c-button--twitter",
    on: {
      "click": function($event) {
        _vm.popup('Twitter')
      }
    }
  }, [_c('icon', {
    staticClass: "c-button__icon",
    attrs: {
      "name": "twitter",
      "role": "img",
      "label": "Twitter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share on Twitter")])], 1)]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "c-button c-button--alt c-button--email",
    attrs: {
      "href": "mailto:?subject=Can%20you%20unlock%20the%20Secret%20Scrolls%20of%20Ikigai%3F&body=The%20pursuit%20of%20your%20true%20passion%20can%20lead%20to%20unthinkably%20wonderful%20things.%20What%20are%20they%3F%20That%E2%80%99s%20for%20you%20to%20find%20out.%0A%0AYour%20journey%20to%20all%20the%20answers%20begin%20here.%20Unlock%20the%20secrets%20of%20ikigai%20and%20you%20can%20be%20in%20the%20chance%20to%20win%20return%20flights%20to%20Japan%20for%20you%20and%20your%20friend%20and%20become%20one%20step%20closer%20to%20discovering%20your%20ikigai%20in%20Japan.%0A%0Ahttp%3A%2F%2Fwww.jnto.org.au%2Fsecretscrolls%3Futm_medium%3DEmail%26utm_source%3DWebsite%26utm_campaign%3DSecretScrolls"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'ShareEmail');
      }
    }
  }, [_c('icon', {
    staticClass: "c-button__icon",
    attrs: {
      "name": "email",
      "role": "img",
      "label": "Email"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Share by Email")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "c-complete__footer"
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/bg-bottom.svg"),
      "alt": ""
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-intro__column s-entry-content s-entry-content--large"
  }, [_c('p', [_c('em', [_vm._v("Your entry has been successfully submitted!")])]), _vm._v(" "), _c('p', [_vm._v("The time has now come. The secret Scroll of Ikigai is now open. From this point on, your life will never be the same again…")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-inari__bubble"
  }, [_c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', [_vm._v("I.N.A.R.I. Yes. I named the passcode after myself, hehe. Sometimes, the answers right in front of you are the hardest to see.")]), _vm._v(" "), _c('p', [_vm._v("I now present you, the secret Scroll of Ikigai. Use it wisely and may it serve you well along the journey to discovering your ikigai in Japan.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("THE SECRET SCROLL OF IKIGAI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-entry-content"
  }, [_c('p', {
    staticClass: "lead"
  }, [_vm._v("Breathe in... and out.")]), _vm._v(" "), _c('p', [_vm._v("Clear your mind of distractions, it’s time to listen to what your heart truly desires and visualise your true passions.")]), _vm._v(" "), _c('p', [_vm._v("On the island of Okinawa, in southern Japan, ikigai is the way of life. The island also has the highest number of centenarians in the world. Some say this is more than coincidence.")]), _vm._v(" "), _c('p', [_vm._v("Are you ready to learn the secret of harnessing your ikigai?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-entry-content"
  }, [_c('h3', [_vm._v("What is ikigai?")]), _vm._v(" "), _c('p', [_vm._v("Ikigai is an age-old Japanese concept that means ‘your reason for being’. Your ikigai is what drives you to get up in the morning. It gives you purpose, and with it, can lead to what we keep searching for... longevity and joyful living.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-entry-content"
  }, [_c('h3', [_vm._v("Ikigai is a mix of:")]), _vm._v(" "), _c('ul', {
    staticClass: "c-flower-list"
  }, [_c('li', [_vm._v("Your passion")]), _vm._v(" "), _c('li', [_vm._v("Your purpose")]), _vm._v(" "), _c('li', [_vm._v("Your satisfaction")]), _vm._v(" "), _c('li', [_vm._v("Your fulfillment")]), _vm._v(" "), _c('li', [_vm._v("Your calling")]), _vm._v(" "), _c('li', [_vm._v("Your true self")]), _vm._v(" "), _c('li', [_vm._v("Your values")]), _vm._v(" "), _c('li', [_vm._v("What’s good for society")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__quote"
  }, [_c('div', {
    staticClass: "s-entry-content"
  }, [_c('blockquote', [_c('p', [_vm._v("A musician must make music, an artist must paint, a poet must write, if he is to be ultimately at peace with himself. What a man can be, he must be")])]), _vm._v(" "), _c('figcaption', [_vm._v("Abraham Maslow")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__quote"
  }, [_c('div', {
    staticClass: "s-entry-content"
  }, [_c('blockquote', {
    staticClass: "c-blockquote--fw"
  }, [_c('p', [_vm._v("What gets you up in the morning (besides your alarm clock)? Mine is deep-fried tofu mmmmm")])]), _vm._v(" "), _c('figcaption', [_vm._v("Inari Fox")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-complete-scroll--section c-complete-scroll__guide"
  }, [_c('div', {
    staticClass: "s-entry-content"
  }, [_c('h3', [_vm._v("MyikiGuide")]), _vm._v(" "), _c('p', [_vm._v("Print out the ‘MyikiGuide’ and fill it in to help you determine your true passion.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("STEPS:")])]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Write down your interests on the left hand column.")]), _vm._v(" "), _c('li', [_vm._v("For each interest, rate how much it applies to each of the 8 elements of ikigai across the other columns out of 10 (10 being very strong).")]), _vm._v(" "), _c('li', [_vm._v("Add up the ratings and write your total on the right hand column.")]), _vm._v(" "), _c('li', [_vm._v("The interest with the highest total may be your true ikigai!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65b1a76e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Complete.vue
// module id = 65
// module chunks = 0